<template>
    <div dusk="ReadProgress" class="flex items-center justify-center px-4 text-sm text-theme-toolbar-icon">
        <div v-if="isPdf" class="px-2">
            <template v-if="currentPages">
                {{ currentPages[0] }}
                <template v-if="currentPages[1]"> - {{ currentPages[1] }}</template>
            </template>
            / {{ publicationNumberOfPages }}
        </div>
        <div v-if="isEpub && (hasSpine || hasR2Positions)" class="px-2">
            <LoadingSpinner v-if="isLoading" class="pt-1" height="18px" width="18px" :not-centered="true" />
            <template v-else>{{ currentEpubPosition || 1 }}%</template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LoadingSpinner from '../Utilities/LoadingSpinner.vue';

export default {
    name: 'ReadProgress',
    components: {
        LoadingSpinner,
    },
    computed: {
        ...mapGetters(['isPdf', 'isEpub', 'currentPages', 'publicationNumberOfPages', 'currentPage']),
        ...mapState(['epub', 'isFixedLayout', 'isLoading', 'lastLocation']),
        hasSpine() {
            return this.epub.spine?.length > 0;
        },
        hasR2Positions() {
            return this.epub.totalPositions > 0;
        },
        currentEpubPosition() {
            if (this.isPdf) return;

            // R2: use totalProgression from locator if available
            if (this.hasR2Positions && this.lastLocation?.epub?.locator?.locations?.totalProgression != null) {
                return Math.round(this.lastLocation.epub.locator.locations.totalProgression * 100);
            }

            // R2 fallback: use position / totalPositions
            if (this.hasR2Positions) {
                const position = parseInt(this.currentPage) || 1;
                return Math.round((position / this.epub.totalPositions) * 100);
            }

            // Legacy R1: word-count based calculation
            if (!this.hasSpine) return;

            if (this.isFixedLayout) {
                return Math.round((parseInt(this.currentPage) * 100) / this.epub.spine.length);
            }

            const page = parseInt(this.currentPage) - 1;
            const spine = this.epub.spine[page];
            if (!spine) return;

            if (Object.keys(this.epub.subSpine).includes('pages') && spine.words) {
                const pages = this.epub.subSpine.pages;
                const currentPosition = this.epub.subSpine.position;
                const words = spine.previous_words + (spine.words / pages) * currentPosition;

                return Math.round((words * 100) / this.epub.totalWords);
            }

            return Math.round(((spine.previous_words + spine.words) * 100) / this.epub.totalWords);
        },
    },
};
</script>
